import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./Context/AuthContext/AuthContext";
import { ThemeProvider } from "./Context/ThemeContext";
import { BrowserRouter } from "react-router-dom";
import { LoaderProvider } from "./Context/LoaderContext";
import { AILoaderProvider } from "./Context/AILoaderContext";
import { initializeGTM } from "./Utils/gtm";
import * as serviceWorkerRegistration from "./Utils/serviceWorkerRegistration";
import { DashboardSideBarProvider } from "./Context/DashboardSideBarContext/DashboardSideBarContext";
import { AppProvider } from "./Context/AppContext/AppContext";
import "./index.css";
import "./index.scss";

initializeGTM();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
        <AuthProvider>
          <AppProvider>
            <DashboardSideBarProvider>
              <ThemeProvider>
                <LoaderProvider>
                  <AILoaderProvider>
                    <App />
                  </AILoaderProvider>
                </LoaderProvider>
              </ThemeProvider>
            </DashboardSideBarProvider>
          </AppProvider>
        </AuthProvider>
      </BrowserRouter>
);

reportWebVitals();

serviceWorkerRegistration.register();
